module.exports = __webpack_public_path__ + "static/media/Loader-bdb.7328b1d8.gif";